<template>
    <v-app>
        <iframe class="free-frame" :src="iframeSrc"></iframe>
    </v-app>
</template>
<style>
    .free-frame {
        width: 100vw;
        height: 100vh;
        border: 0;
    }
</style>
<script>

    export default {
        data() {
            return {
                iframeSrc: null
            }
        },
        mounted() {
            this.iframeSrc = this.$route.params.url;
        },
        created() {
            EventBus.$emit('app-show-body');
        }
    }
</script>